import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import translation from './lang.json';
import { langTypes } from 'config/langType';
import localLang from './local-lang.json';

/**
 * 合併本地化翻譯資源到主要翻譯資源
 * @param {Object} mainRes - 主要翻譯資源 (lang.json)
 * @param {Object} localRes - 本地化翻譯資源 (local-lang.json)
 * @returns {Object} 合併後的翻譯資源
 */
const mergeTranslationResources = (mainRes, localRes) => {
    const mergedResources = { ...mainRes };

    // 遍歷所有語系
    Object.keys(localRes).forEach(lang => {
        if (!mergedResources[lang]) {
            mergedResources[lang] = {};
        }

        // 合併翻譯內容，local-lang.json 的內容會覆蓋 lang.json 的相同鍵值
        Object.keys(localRes[lang]).forEach(key => {
            mergedResources[lang][key] = localRes[lang][key];
        });
    });

    return mergedResources;
};

// 合併翻譯資源
const mergedResources = mergeTranslationResources(translation, localLang);
const resources = Object.entries(mergedResources).reduce((newObj, [key, value]) => {
    newObj[key] = { translation: value };
    return newObj;
}, {});

i18next
    .use(ICU)
    .use(initReactI18next)
    .init({
        resources,
        lng: langTypes.ZH_TW,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
